import React, { useCallback } from 'react';
import { FileDropZone, SdiTrash, styles } from '@sdir/sds';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { FileViewer } from './FileViewer';

interface FileDropProps {
  file: File | null;
  onFileChange: (file: File | null) => void;
  name?: string;
  documentDisplayClass?: string;
}

export const FileDrop: React.FC<FileDropProps> = ({
  file,
  onFileChange,
  name,
  documentDisplayClass,
}) => {
  const intl = useIntl();

  const handleFilesSelected = useCallback(
    (f: File[]) => {
      onFileChange(f[0] || null);
    },
    [onFileChange]
  );

  const handleFileRemoved = useCallback(() => {
    onFileChange(null);
  }, [onFileChange]);

  return (
    <UploadContainer>
      {file ? (
        <FileViewWrapper>
          <FileViewer file={file} documentDisplayClass={documentDisplayClass} />
          <RemoveFileLink onClick={handleFileRemoved}>
            <SdiTrash size="s" color={styles.colors.alert.errorDark} />
            <span className="btn-text">
              {intl.formatMessage({ id: 'general.form.deletedocument' })}
            </span>
          </RemoveFileLink>
        </FileViewWrapper>
      ) : (
        <FileDropZone
          name={name}
          label={intl.formatMessage({ id: 'general.form.dropfile' })}
          allowedTypes=".png,.jpg,.jpeg,.pdf"
          onFilesSelected={handleFilesSelected}
          onFilesDrop={handleFilesSelected}
        />
      )}
    </UploadContainer>
  );
};

const UploadContainer = styled.div`
  max-height: 100%;
`;

const FileViewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const RemoveFileLink = styled.button`
  background: none;
  border: none;
  box-shadow: none;
  color: ${styles.colors.alert.errorDark};
  display: flex;
  margin-top: 16px;

  .btn-text {
    margin-left: 8px;
  }

  &:hover,
  &:focus {
    cursor: pointer;

    .btn-text {
      text-decoration: underline;
    }
  }
`;
